import isBoolean from "lodash/isBoolean";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useGoBack } from '@/shared/composables/goBack';
import { useRoute } from 'vue-router/composables';
import { existsNavBar, getTitle } from '@/shared/util';
export default /*#__PURE__*/ _defineComponent({
    __name: 'standard-layout',
    setup: function setup(__props) {
        var goBack = useGoBack();
        var route = useRoute();
        var showNavBar = computed(function() {
            var _route_meta;
            if (((_route_meta = route.meta) === null || _route_meta === void 0 ? void 0 : _route_meta.customNavBar) === true) {
                return false;
            }
            return existsNavBar(route);
        });
        var canBack = computed(function() {
            var _route_meta;
            if (isBoolean((_route_meta = route.meta) === null || _route_meta === void 0 ? void 0 : _route_meta.canBack)) {
                var _route_meta1;
                return (_route_meta1 = route.meta) === null || _route_meta1 === void 0 ? void 0 : _route_meta1.canBack;
            }
            return true;
        });
        var title = computed(function() {
            return getTitle(route);
        });
        return {
            __sfc: true,
            goBack: goBack,
            route: route,
            showNavBar: showNavBar,
            canBack: canBack,
            title: title
        };
    }
});
